import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  message,
} from "antd";
import { withRouter } from "react-router-dom";
import { API } from "../../API/API";
import UserContext from "../UserContext/UserContext";
const dateFormat = "YYYY.MM.DD";
var moment = require("moment");
const { TextArea } = Input;
class JoinWorkAdd extends Component {
  static contextType = UserContext;
  formRef = React.createRef();
  state = {
    parentid: this.props.parentid,
    joinworkid: this.props.joinworkid,
    tendertypelist: [],
    deplist: [],
    joinworkcode: "",
    joinworkname: "",
    tendertypeid: null,
    departmentid: null,
    startdate: null,
    enddate: null,
    note: "",
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getJoinWorkInitialData?joinworkid=" + this.state.joinworkid).then(
      (response) => {
        if (response.status === 200) {
          this.setState({
            tendertypelist: response.data.retData[0],
            deplist: response.data.retData[1],
          });
          if (response.data.retData[2].length > 0) {
            this.setState((prevState) => ({
              joinworkcode: response.data.retData[2][0].joinworkcode,
              joinworkname: response.data.retData[2][0].joinworkname,
              tendertypeid: response.data.retData[2][0].tendertypeid,
              departmentid: response.data.retData[2][0].departmentid,
              startdate: response.data.retData[2][0].startdate,
              enddate: response.data.retData[2][0].enddate,
              
              note: response.data.retData[2][0].note,
              dkey: prevState.dkey + 1,
            }));
          }
        }
      }
    );
  };
  onChangeName = (value) => {
    this.setState({ joinworkname: value });
  };
  onChangeType = (value) => {
    this.setState({ tendertypeid: value });
  };
  onChangeDep = (value) => {
    this.setState({ departmentid: value });
  };
  onChangeStartDate = (value) => {
    this.setState({ startdate: value });
  };
  onChangeEndDate = (value) => {
    this.setState({ enddate: value });
  };
  onChangeNote = (value) => {
    this.setState({ note: value });
  };
  onSave = () => {
    if (
      this.state.joinworkname &&
      this.state.tendertypeid &&
      this.state.departmentid &&
      this.state.startdate &&
      this.state.enddate &&
      this.state.note
    ) {
      if (this.state.startdate > this.state.enddate) {
        message.warning("Уучлаарай. Зарлах огноо дуусах огнооноос их байх боломжгүй.");
      }
      else {
        let body = {
          joinworkid: this.state.parentid === 0 ? this.state.joinworkid : 0,
          joinworkcode: this.state.joinworkcode,
          joinworkname: this.state.joinworkname,
          tendertypeid: this.state.tendertypeid,
          departmentid: this.state.departmentid,
          startdate: this.state.startdate,
          enddate: this.state.enddate,
          createdby: this.context.username,
          note: this.state.note,
        };
        API.post("/saveJoinWork", body).then((response) => {
          if (response.status === 200) {
            message.success("Амжилттай хадгаллаа.");
            this.props.showForm(false, 0);
          }
        });
      }
    }
  };
  render() {
    return (
      <div key={this.state.dkey} id="joinwork">
        <Form
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Код"
                name="joinworkcode"
                initialValue={this.state.joinworkcode}
              >
                <Input
                  style={{ height: 30 }}
                  size="large"
                  defaultValue={this.state.joinworkcode}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Нэр"
                name="joinworkname"
                rules={[
                  {
                    required: true,
                    message: "Нэр оруулна уу.",
                  },
                ]}
                initialValue={this.state.joinworkname}
              >
                <Input
                  style={{ height: 30 }}
                  disiabled
                  size="large"
                  defaultValue={this.state.joinworkname}
                  onChange={(e) => this.onChangeName(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Төрөл"
                name="tendertypeid"
                rules={[
                  {
                    required: true,
                    message: "Төрөл сонгоно уу.",
                  },
                ]}
                initialValue={this.state.tendertypeid}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeType}
                  defaultValue={this.state.tendertypeid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.tendertypelist &&
                    this.state.tendertypelist?.map((t, i) => (
                      <Select.Option key={i} value={t.tendertypeid}>
                        {t.tendertypename}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Захиалагч"
                name="departmentid"
                rules={[
                  {
                    required: true,
                    message: "Захиалагч сонгоно уу.",
                  },
                ]}
                initialValue={this.state.departmentid}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeDep}
                  defaultValue={this.state.departmentid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.deplist &&
                    this.state.deplist?.map((t, i) => (
                      <Select.Option key={i} value={t.departmentid}>
                        {t.departmentname}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Зарлах огноо"
                name="startdate"
                initialValue={
                  this.state.startdate
                    ? moment(this.state.startdate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо сонгоно уу.",
                  },
                ]}
              >
                <DatePicker
                  defaultValue={
                    this.state.startdate
                      ? moment(this.state.startdate, dateFormat)
                      : null
                  }
                  onChange={this.onChangeStartDate}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Дуусах огноо"
                name="enddate"
                initialValue={
                  this.state.enddate
                    ? moment(this.state.enddate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо сонгоно уу.",
                  },
                ]}
              >
                <DatePicker
                  defaultValue={
                    this.state.enddate
                      ? moment(this.state.enddate, dateFormat)
                      : null
                  }
                  onChange={this.onChangeEndDate}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Дэлгэрэнгүй тайлбар"
                name="note"
                rules={[
                  {
                    required: true,
                    message: "Тайлбар оруулна уу.",
                  },
                ]}
                initialValue={this.state.note}
              >
                <TextArea
                  onChange={(e) => this.onChangeNote(e.target.value)}
                  rows={5}
                  defaultValue={this.state.note}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              type="primary"
              style={{
                width: "100%",
                backgroundColor: "#0358A7",
                borderRadius: 2,
              }}
              htmlType="submit"
              onClick={this.onSave}
            >
              {this.state.parentid === 0 ? "Хадгалах" : "Хуулах"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(JoinWorkAdd);
